import Carrier from './Carrier.enum';

/**
 * - id {number}: The CarrierID recognized in ShipStation.
 * - key {string}: The key of Carrier enum object.
 * - displayName {string}: The human-friendly text to display in the UI.
 * - value {Carrier}: Carrier enum value.
 */
export default Object.freeze([
	{
		id: 3,
		key: 'UPS',
		displayName: 'UPS',
		value: Carrier.UPS,
	},
	{
		id: 1,
		key: 'USPS',
		displayName: 'USPS',
		value: Carrier.USPS,
	},
	{
		id: 4,
		key: 'FedEx',
		displayName: 'FedEx',
		value: Carrier.FedEx,
	},
	{
		id: 38,
		key: 'DHLExpress',
		displayName: 'DHL Express',
		value: Carrier.DHLExpress,
	},
	{
		id: 60,
		key: 'GlobalPost',
		displayName: 'GlobalPost',
		value: Carrier.GlobalPost,
	},
]);
